import type { AdvantagesProps } from './advantages.types';
import { Check } from 'lucide-react';
import clsx from 'clsx';
import CtaButton from '@/components/landing-page/components/cta-button';
import tabletsDlpSrc from '@/components/landing-page/components/advantages/assets/tablets-dlp.jpg';
import { defaults } from '@/components/landing-page/components/advantages';
import { cn } from '@/utils/helper';
import v1 from '@/components/landing-page/components/advantages/advantages-v1.module.css';
import v2 from '@/components/landing-page/components/advantages/advantages-v2.module.css';

export default function Advantages(props: AdvantagesProps) {
  const {
    title = defaults.title,
    list = defaults.list,
    withImage = defaults.withImage,
    withoutButton = defaults.withoutButton,
  } = props;

  return (
    <div
      data-testid='advantages'
      className={clsx(cn(v1.Advantages, v2.Advantages), {
        [cn(v1.AdvantagesWithImage, v2.AdvantagesWithImage)]: withImage,
      })}
    >
      <h6 data-testid='advantages-head' className={cn(v1.Title, v2.Title)}>
        {title}
      </h6>
      <ul className={cn(v1.List, v2.List)}>
        {list.map((listItem, i) => (
          <li key={i} data-testid='advantages-list-item' className={cn(v1.Item, v2.Item)}>
            <Check className={cn(v1.CheckIcon, v2.CheckIcon)} />
            <div className={cn(v1.Text, v2.Text)}>{listItem}</div>
          </li>
        ))}
        {withImage && !withoutButton ? (
          <li data-testid='advantages-button' className={cn(v1.Button, v2.Button)}>
            <CtaButton />
          </li>
        ) : null}
      </ul>
      {withImage ? (
        <img data-testid='advantages-image' src={tabletsDlpSrc} alt='tablets-dlp' className={cn(v1.Image, v2.Image)} />
      ) : null}
    </div>
  );
}
